module.exports = __webpack_public_path__ + "img/promotion5.d5ef9ab8.png";